import { getFeatureToggle } from '../hn-feature-toggle';
import { erHelsenorge, erTjenester } from '../hn-proxy-service';
import { ampli } from './ampli';
import { safeLoadAmplitude } from './initialization';
/**
 * Hent "brukerflate" basert på hvilken del av helsenorge.no brukeren er på
 */
export const getBrukerflate = () => {
    if (erHelsenorge()) {
        return 'www';
    }
    if (erTjenester()) {
        return 'tjenester';
    }
};
/**
 * Aktiverer eller deaktiverer webanalyse
 *
 * @param optOut Om brukeren har gitt samtykke til webanalyse
 */
export const setOptOut = (optOut) => {
    if (!getFeatureToggle('AmplitudeEnabled')) {
        return;
    }
    if (!ampli.isLoaded) {
        safeLoadAmplitude();
    }
    ampli.client.setOptOut(optOut);
};
/**
 * Sporer et event til Amplitude
 *
 * @param event Event-data
 * @param options Ytterligere opsjoner for eventet
 */
export const track = (event, options) => {
    if (!getFeatureToggle('AmplitudeEnabled')) {
        return;
    }
    if (!ampli.isLoaded) {
        safeLoadAmplitude();
    }
    ampli.track(event, options);
};
/**
 * Sett user properties i Amplitude basert på data fra AnalyticsDataLayer
 */
export function setUserProperties(properties) {
    if (!getFeatureToggle('AmplitudeEnabled')) {
        return;
    }
    if (!ampli.isLoaded) {
        safeLoadAmplitude();
    }
    ampli.identify(undefined, properties);
}
